export default {
  route: {
    dashboard: '首页',
    manage: '后台管理',
    users: '用户管理',
    menus: '菜单管理',
    permissions: '权限管理',
    logs: '日志管理',
    example: '示例',
    table: '数据列表',
 
    list: '列表页',
    tableList: '查询表格',
    basicList: '标准列表',
    cardList: '卡片列表',

    form: '表单页',
    basicForm: '基础表单',
    stepForm: '分步表单',
    advancedList: '高级表单',
    step: '步骤',

    details: '详情页',
    BasicsDetails: '基础详情页',
    seniorDetails: '高级详情页',
    enterprise: '企业管理'
  },
  navbar: {
    search: '站内搜索',
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    lang: '多语言',
    error: '错误日志'
  },
  login: {
    title: 'SPA后台管理系统',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  table: {
    title: '请输入用户',
    search: '搜索',
    add: '添加',
    addUser: '新增用户',
    id: '序号',
    email: '邮箱',
    phone: '联系电话',
    username: '用户名',
    source: '来源',
    role: '角色',
    account: '账号',
    creatdate: '创建日期',
    remarks: '备注',
    state: '状态',
    prohibit: '禁用',
    permissionNew: '新增权限组',
    permissionUser: '权限组名称',
    imdsAi: '高级接口授权',
    avatar: '头像',
    introduction: '介绍',
    paddword: '密码',
    confirmPaddword: '确认密码',
    powerCode: '权限代码',
    powerDistriB: '权限分配',
    powerTitle: '权限标题',
    powerNav: '主导航',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    operationType: '操作类型',
    operationDate: '操作时间',
    date: '日期',
    operator: '操作人',
    results: '执行结果',
    describe: '描述',
    preserve: '保存',
    signOut: '退出'
  }
}
